import BaseBetweenTime from "@/project/model/base/BaseBetweenTime";

export default class LoginRecordModel extends BaseBetweenTime {

    id = 0;
    ip = '';
    uid = 0;
    type = 0;
    createTime = '';

    typeText = '';

}